var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.maskIconSrc)?_c('span',{staticClass:"icon icon--mask",style:(_vm.maskStyles),attrs:{"aria-hidden":"true"}}):_c('svg',{staticClass:"icon",style:(_vm.styles),attrs:{"width":"0","height":"0"}},[_c('use',{attrs:{"xlink:href":require('@/assets/img/icons.svg') + '#' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }